import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
export const isColumnTotalInvalid = (columns) => (columns
    .reduce((total, value) => (total + value), 0) !== 12);
export const convertColumnsToStyleValue = (columns) => ((Array.isArray(columns)
    ? (columns
        .map((columnWeight) => (`${columnWeight}fr`))
        .reduce((styleProp, columnWeight) => (`${styleProp} ${columnWeight}`)))
    : `repeat(${columns}, minmax(0, 1fr))`));
export const convertColumnsToObject = (columns) => (Array.isArray(columns)
    || typeof columns === 'number'
    ? {
        default: columns,
    }
    : columns);
export const getGridColumnStyles = (columns) => (Object
    .keys(columns)
    .map((key) => ({
    breakpoint: key,
    columnsStyle: convertColumnsToStyleValue(columns[key]),
}))
    .map(({ breakpoint, columnsStyle, }) => (theme.media.greaterThan(breakpoint)(`grid-template-columns: ${columnsStyle};`))));
const defaultProps = {
    className: '',
    columnSpacing: 'none',
    rowSpacing: 'none',
};
const Grid = ({ children, className = defaultProps.className, columnSpacing = defaultProps.columnSpacing, columns, rowSpacing = defaultProps.rowSpacing, }) => {
    if (Array.isArray(columns)
        && isColumnTotalInvalid(columns)) {
        throw new Error('Invalid prop value for `Grid.columns`. Grid columns need to add up to 12.');
    }
    else if (typeof columns === 'object') {
        Object
            .entries(columns)
            .forEach(([breakpointName, columnData,]) => {
            if (Array.isArray(columnData)
                && isColumnTotalInvalid(columnData)) {
                throw new Error(`Invalid prop value for \`Grid.columns\`: \`${breakpointName}\`. Grid columns need to add up to 12.`);
            }
        });
    }
    const localColumnSpacing = useMemo(() => (columnSpacing === '1px'
        ? styleUtils.rem(1)
        : theme.spacing[columnSpacing]), [
        columnSpacing,
    ]);
    const localRowSpacing = useMemo(() => (rowSpacing === '1px'
        ? styleUtils.rem(1)
        : theme.spacing[rowSpacing]), [
        rowSpacing,
    ]);
    const gridStyles = useMemo(() => (css `
        display: grid;
        grid-column-gap: ${localColumnSpacing};
        grid-row-gap: ${localRowSpacing};
        ${getGridColumnStyles(convertColumnsToObject(columns))}
      `), [
        columns,
        localColumnSpacing,
        localRowSpacing,
    ]);
    return (_jsx("div", Object.assign({ className: className, css: gridStyles }, { children: children })));
};
const MemoizedGrid = memo(Grid);
export { MemoizedGrid as Grid };
// MC-1068 Temporary hack for Storybook.
export default Grid;
